<template>
  <div>
    <ITIndividualUpload
      :selected_emp="selected_emp"
      :individual_dialog="individual_dialog"
      :closeIndividualDialog="closeIndividualDialog"
    />
    <v-card>
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Funcionários</v-toolbar-title>
      </v-toolbar>
      <v-card-actions>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mx-2"
        ></v-text-field>
      </v-card-actions>
      <v-data-table :items="employees" :headers="headers" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn text medium icon @click="openIndividualDialog(item)">
            <v-icon medium color="blue"> mdi-cloud-upload </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ITIndividualUpload from './ITIndividualUpload.vue'

export default {
  name: 'ITListEmployee',
  components: { ITIndividualUpload },
  data: () => {
    return {
      search: '',
      individual_dialog: false,
      multiple_dialog: false,
      selected_emp: '',
      headers: [
        { text: 'Nome do Funcionário', align: 'start', sortable: false, value: 'full_name' },
        { text: 'Lotação', value: 'workstation_name' },
        { text: 'Setor', value: 'department_name' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
    }
  },
  computed: { ...mapState('employees', ['employees']) },
  methods: {
    closeIndividualDialog() {
      this.individual_dialog = false
      this.selected_emp = ''
    },
    closeMultipleDialog() {
      this.individual_dialog = false
      this.selected_emp = ''
    },
    openIndividualDialog(emp) {
      this.individual_dialog = true
      this.selected_emp = emp
    },
  },
}
</script>
